import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './LkmAppealOfferButtons.module.scss'

type LkmAppealOfferModalProps = {
  isSubmitButtonDisabled: boolean
  isLoading: boolean
  handleClose: () => void
}

export function LkmAppealOfferButtons({
  isSubmitButtonDisabled,
  isLoading,
  handleClose,
}: LkmAppealOfferModalProps) {
  return (
    <div className={style.appealOfferButtons}>
      <Button
        color='primary'
        variant='contained'
        disabled={isSubmitButtonDisabled}
        size='large'
        type='submit'
        className={style.appealOfferButtons__submitButton}
        data-testid='lkm-offer-submit'
      >
        {isLoading && <LoaderInCentalPosition className={style.loader} />}
        Отправить
      </Button>
      <Button
        color='primary'
        variant='text'
        size='large'
        onClick={handleClose}
        className={style.appealOfferButtons__backButton}
        data-testid='lkm-offer-back'
      >
        Назад
      </Button>
    </div>
  )
}
